// Copyright (c) Ping. All rights reserved.
//
// Mounts the first-run app tour. Auto-starts once per user (gated on the
// `tour.home.seen` flag) the first time the authenticated shell renders.

import { useMemo } from 'react';

import { useRouter } from '@shell/RouterContext';

import { GuidedTourHost } from './GuidedTour';
import { buildHomeTourSteps } from './homeTourSteps';
import { TOUR_HOME } from './tourIds';

// Above the recovery nudge so the intro runs first when both are waiting.
const HOME_TOUR_PRIORITY = 20;

export function HomeTourHost(): JSX.Element {
  const router = useRouter();
  const steps = useMemo(() => buildHomeTourSteps(router), [router]);
  return <GuidedTourHost tourId={TOUR_HOME} steps={steps} priority={HOME_TOUR_PRIORITY} />;
}
